import http from '@/services/http/http'

export async function listWalletTransactions(opts) {
  const url = '/api/v1/wallet_transactions'
  const { data } = await http.get(url, {params: opts})
  return data
}